var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
var ActiveTabContext = createContext(undefined);
export var ActiveTabProvider = function (_a) {
    var children = _a.children;
    var _b = useState("tokens"), activeTab = _b[0], setActiveTab = _b[1]; // "settings" o "tokens"
    return (_jsx(ActiveTabContext.Provider, __assign({ value: { activeTab: activeTab, setActiveTab: setActiveTab } }, { children: children })));
};
export var useActiveTab = function () {
    var context = useContext(ActiveTabContext);
    if (!context) {
        throw new Error("useActiveTab debe ser usado dentro de un ActiveTabProvider");
    }
    return context;
};
